import React from 'react';
// import clsx from 'clsx';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {Field, getFormValues, reduxForm} from 'redux-form';

import RotateLeftIcon from '@mui/icons-material/RotateLeft';
import SearchIcon from '@mui/icons-material/Search';
import Divider from '@mui/material/Divider';
import Grid from '@mui/material/Grid';
import {withStyles} from '@mui/styles';
// import PublishIcon from '@mui/icons-material/Publish';
// import EditIcon from '@mui/icons-material/Edit';
// import DeleteIcon from '@mui/icons-material/Delete';
// import AddIcon from '@mui/icons-material/Add';
// import GetAppIcon from '@mui/icons-material/GetApp';
// import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
// import InfoOutlined from '@mui/icons-material/InfoOutlined';
// import Printicon from '@mui/icons-material/Print';
import {} from '@mui/lab';
import {} from '@mui/material';
import MenuItem from '@mui/material/MenuItem';
import Typography from '@mui/material/Typography';

import {
  FlexGridColumnGroup,
} from '@grapecity/wijmo.react.grid';

import {} from '../../../../common/common.js';
import {GMN, GMN_PATH} from '../../../../common/commonConst.js';
import {attachorderOperations} from '../../../../reducks/attachorder';
import {commonOperations} from '../../../../reducks/common';
import {renderSelect, renderSelectMultiLine} from '../../../atoms/CustomPart.js';
import MainContainer from '../../../organisms/MainContainer.js';
// import {createSearchList} from '../../../../../common/ComboParts.js';
import CustomFlexGrid from '../../../molecules/CustomFlexGrid.js';
// import MuiTooltip from '../../../../atoms/MuiTooltip.js';
// import BackButton from '../../../atoms/Buttons/BackButton.js';
import NegativeButton from '../../../atoms/Buttons/NegativeButton.js';
import {PositiveButton} from '../../../atoms/Buttons/PositiveButton.js';
// import KyogaCompanyInfo from '../../../../molecules/KyogaCompanyInformation.js';
// import * as validateRule from '../../../validateRule.js';
import {CellMaker} from '@grapecity/wijmo.grid.cellmaker';
import SaveIcon from '@mui/icons-material/Save';
import {setSessionObject} from '../../../../common/Session.js';
import PaperPart from '../../../atoms/PaperPart.js';
import WarningMessageArea from '../../../molecules/WarningMessageArea.js';
import ApprovalStatus from '../../../organisms/Approval/ApprovalStatus/index.js';
import withRouter from '../../../organisms/withRouter.js';
// import ApprovalCommentTstk from '../../../organisms/Approval/ApprovalCommentTstk/index.js';
import {CellType} from '@grapecity/wijmo.grid';
import Cancel from '@mui/icons-material/Cancel';
import CheckCircle from '@mui/icons-material/CheckCircle';
import DangerButton from '../../../atoms/Buttons/DangerButton.js';
import CustomAccordion from '../../../molecules/Accordion.js';
import CustomBreadcrumbs from '../../../molecules/Breadcrumbs.js';
import ApprovalCommentTstk from '../../../organisms/Approval/ApprovalComment/index.js';
// パンくずパラメータ
const transitionList = [
  {gmnName: GMN.MENU.name, href: GMN_PATH.MENU},
  {gmnName: GMN.ANNUAL_SURVERY_PLAN_LIST.name, href: ''},
];
const styles = (theme) => ({

});

// 一覧
const planViews = [
  // {binding: 'nwJigyosyo', header: '統合前NW事業所', dataType: 'String', width: 95, readOnly: true},
  {binding: 'nwJigyosyo', header: '旧NW事業所', dataType: 'String', width: 90, readOnly: true},
  {binding: 'tskkJgyosyo', header: '調査機関事業所', dataType: 'CellMaker', width: 80, readOnly: true},
  {binding: 'gyosyu', header: '分類', dataType: 'String', width: 200, readOnly: true},
  {header: '2027年', dataType: 'header', elems: [
    {binding: 'month4', header: '4月', dataType: 'Number', width: 65, readOnly: true},
    {binding: 'month5', header: '5月', dataType: 'Number', width: 65, readOnly: true},
    {binding: 'month6', header: '6月', dataType: 'Number', width: 65, readOnly: true},
    {binding: 'month7', header: '7月', dataType: 'Number', width: 65, readOnly: true},
    {binding: 'month8', header: '8月', dataType: 'Number', width: 65, readOnly: true},
    {binding: 'month9', header: '9月', dataType: 'Number', width: 65, readOnly: true},
    {binding: 'month10', header: '10月', dataType: 'Number', width: 70, readOnly: true},
    {binding: 'month11', header: '11月', dataType: 'Number', width: 70, readOnly: true},
    {binding: 'month12', header: '12月', dataType: 'Number', width: 70, readOnly: true},
  ]},
  {header: '2028年', dataType: 'header', elems: [
    {binding: 'month1', header: '1月', dataType: 'Number', width: 65, readOnly: true},
    {binding: 'month2', header: '2月', dataType: 'Number', width: 65, readOnly: true},
    {binding: 'month3', header: '3月', dataType: 'Number', width: 65, readOnly: true},
  ]},
  {binding: 'sinnseiStatus', header: 'ステータス', dataType: 'CellMaker', width: 115, readOnly: false},
];

// 年度計画登録(担当者)
const totalViews = [
  {binding: 'tyousakei', header: '調査箇所数（件）', type: 'text', width: 250, readOnly: false},
  {binding: 'goukei', header: '合計', type: 'text', width: 765, readOnly: false},
];

// const exceptFiltersBindings = [
//   'month4', 'month5', 'month6', 'month7', 'month8', 'month9', 'month10',
//   'month11', 'month12', 'month1', 'month2', 'month3', 'sinnseiStatus',
// ];

/**
 * 年度計画登録画面
 * 画面ID:SCE1001
 */
class Container extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      buttonDisabled: true,
      buttonDisabled2: true,
      warningMessages: [],
    };

    this.gridRef = React.createRef();
    this.gridTotalRef = React.createRef();
  }

  /**
   * 初期処理
   */
  async componentDidMount() {
    try {
      this.props.doSetReferenceMode(false);
      // FlexGridに初期値設定
      if (this.gridRef && this.gridRef.current) {
        // this.gridRef.current.setInitItems('1001', []);
      }
    } catch (error) {
      this.props.doShowMessage({
        message: 'TKSCS00001S',
        action: () => {
          this.props.history.push('/login');
        },
      });
    }
  }

  /**
     * 終了処理
     */
  async componentWillUnmount() {
    this.props.reset();
    this.props.doClearOrderList();
    this.props.doClearOrder();
    // if (this.gridRef && this.gridRef.current) {
    //   this.gridRef.current.saveScreenState('1001', 'Id');
    //   this.gridRef.current.setItems(null);
    // }
  }

  /**
   * 検索処理
   */
  _searchOrder = async () => {
    const data =[
      {nwJigyosyo: '広島北', tskkJgyosyo: '広島支', gyosyu: '総計（件）', month4: '3,000', month5: '3,000', month6: '3,000', month7: '3,000', month8: '3,000', month9: '3,000', month10: '3,000', month11: '3,000', month12: '3,000', month1: '3,000', month2: '3,000', month3: '3,000', sinnseiStatus: '作成中', hiKetuFlag: '0'},
      {nwJigyosyo: '', tskkJgyosyo: '', gyosyu: '4年周期（件）', month4: '3,000', month5: '3,000', month6: '3,000', month7: '3,000', month8: '3,000', month9: '3,000', month10: '3,000', month11: '3,000', month12: '3,000', month1: '3,000', month2: '3,000', month3: '3,000', sinnseiStatus: '', hiKetuFlag: '0'},
      {nwJigyosyo: '', tskkJgyosyo: '', gyosyu: '　定額', month4: '3,000', month5: '3,000', month6: '3,000', month7: '3,000', month8: '3,000', month9: '3,000', month10: '3,000', month11: '3,000', month12: '3,000', month1: '3,000', month2: '3,000', month3: '3,000', sinnseiStatus: '', hiKetuFlag: '0'},
      {nwJigyosyo: '', tskkJgyosyo: '', gyosyu: '　定額以外', month4: '3,000', month5: '3,000', month6: '3,000', month7: '3,000', month8: '3,000', month9: '3,000', month10: '3,000', month11: '3,000', month12: '3,000', month1: '3,000', month2: '3,000', month3: '3,000', sinnseiStatus: '', hiKetuFlag: '0'},

      {nwJigyosyo: '', tskkJgyosyo: '', gyosyu: '毎年調査（件）', month4: '3,000', month5: '3,000', month6: '3,000', month7: '3,000', month8: '3,000', month9: '3,000', month10: '3,000', month11: '3,000', month12: '3,000', month1: '3,000', month2: '3,000', month3: '3,000', sinnseiStatus: '', hiKetuFlag: '0'},

      {nwJigyosyo: '', tskkJgyosyo: '', gyosyu: '　寝老人', month4: '3,000', month5: '3,000', month6: '3,000', month7: '3,000', month8: '3,000', month9: '3,000', month10: '3,000', month11: '3,000', month12: '3,000', month1: '3,000', month2: '3,000', month3: '3,000', sinnseiStatus: '', hiKetuFlag: '0'},
      {nwJigyosyo: '', tskkJgyosyo: '', gyosyu: '　プール', month4: '3,000', month5: '3,000', month6: '3,000', month7: '3,000', month8: '3,000', month9: '3,000', month10: '3,000', month11: '3,000', month12: '3,000', month1: '3,000', month2: '3,000', month3: '3,000', sinnseiStatus: '', hiKetuFlag: '0'},
      {nwJigyosyo: '', tskkJgyosyo: '', gyosyu: '　公衆浴場', month4: '3,000', month5: '3,000', month6: '3,000', month7: '3,000', month8: '3,000', month9: '3,000', month10: '3,000', month11: '3,000', month12: '3,000', month1: '3,000', month2: '3,000', month3: '3,000', sinnseiStatus: '', hiKetuFlag: '0'},
      {nwJigyosyo: '', tskkJgyosyo: '', gyosyu: '　学校等', month4: '3,000', month5: '3,000', month6: '3,000', month7: '3,000', month8: '3,000', month9: '3,000', month10: '3,000', month11: '3,000', month12: '3,000', month1: '3,000', month2: '3,000', month3: '3,000', sinnseiStatus: '', hiKetuFlag: '0'},
      {nwJigyosyo: '', tskkJgyosyo: '', gyosyu: '　病院等', month4: '3,000', month5: '3,000', month6: '3,000', month7: '3,000', month8: '3,000', month9: '3,000', month10: '3,000', month11: '3,000', month12: '3,000', month1: '3,000', month2: '3,000', month3: '3,000', sinnseiStatus: '', hiKetuFlag: '0'},
      {nwJigyosyo: '', tskkJgyosyo: '', gyosyu: '　老人福祉施設', month4: '3,000', month5: '3,000', month6: '3,000', month7: '3,000', month8: '3,000', month9: '3,000', month10: '3,000', month11: '3,000', month12: '3,000', month1: '3,000', month2: '3,000', month3: '3,000', sinnseiStatus: '', hiKetuFlag: '0'},
      {nwJigyosyo: '', tskkJgyosyo: '', gyosyu: '　重要文化財', month4: '3,000', month5: '3,000', month6: '3,000', month7: '3,000', month8: '3,000', month9: '3,000', month10: '3,000', month11: '3,000', month12: '3,000', month1: '3,000', month2: '3,000', month3: '3,000', sinnseiStatus: '', hiKetuFlag: '0'},
      {nwJigyosyo: '', tskkJgyosyo: '', gyosyu: '　学校・プール', month4: '3,000', month5: '3,000', month6: '3,000', month7: '3,000', month8: '3,000', month9: '3,000', month10: '3,000', month11: '3,000', month12: '3,000', month1: '3,000', month2: '3,000', month3: '3,000', sinnseiStatus: '', hiKetuFlag: '0'},

      {nwJigyosyo: '', tskkJgyosyo: '', gyosyu: '点検（件）', month4: '3,000', month5: '3,000', month6: '3,000', month7: '3,000', month8: '3,000', month9: '3,000', month10: '3,000', month11: '3,000', month12: '3,000', month1: '3,000', month2: '3,000', month3: '3,000', sinnseiStatus: '', hiKetuFlag: '0'},
      {nwJigyosyo: '', tskkJgyosyo: '', gyosyu: '　同調', month4: '3,000', month5: '3,000', month6: '3,000', month7: '3,000', month8: '3,000', month9: '3,000', month10: '3,000', month11: '3,000', month12: '3,000', month1: '3,000', month2: '3,000', month3: '3,000', sinnseiStatus: '', hiKetuFlag: '0'},
      {nwJigyosyo: '', tskkJgyosyo: '', gyosyu: '　単独', month4: '3,000', month5: '3,000', month6: '3,000', month7: '3,000', month8: '3,000', month9: '3,000', month10: '3,000', month11: '3,000', month12: '3,000', month1: '3,000', month2: '3,000', month3: '3,000', sinnseiStatus: '', hiKetuFlag: '0'},

      {nwJigyosyo: '廿日市', tskkJgyosyo: '広島支', gyosyu: '総計（件）', month4: '3,000', month5: '3,000', month6: '3,000', month7: '3,000', month8: '3,000', month9: '3,000', month10: '3,000', month11: '3,000', month12: '3,000', month1: '3,000', month2: '3,000', month3: '3,000', sinnseiStatus: '報告中', hiKetuFlag: '1'},
      {nwJigyosyo: '', tskkJgyosyo: '', gyosyu: '4年周期（件）', month4: '3,000', month5: '3,000', month6: '3,000', month7: '3,000', month8: '3,000', month9: '3,000', month10: '3,000', month11: '3,000', month12: '3,000', month1: '3,000', month2: '3,000', month3: '3,000', sinnseiStatus: '', hiKetuFlag: '0'},
      {nwJigyosyo: '', tskkJgyosyo: '', gyosyu: '　定額', month4: '3,000', month5: '3,000', month6: '3,000', month7: '3,000', month8: '3,000', month9: '3,000', month10: '3,000', month11: '3,000', month12: '3,000', month1: '3,000', month2: '3,000', month3: '3,000', sinnseiStatus: '', hiKetuFlag: '0'},
      {nwJigyosyo: '', tskkJgyosyo: '', gyosyu: '　定額以外', month4: '3,000', month5: '3,000', month6: '3,000', month7: '3,000', month8: '3,000', month9: '3,000', month10: '3,000', month11: '3,000', month12: '3,000', month1: '3,000', month2: '3,000', month3: '3,000', sinnseiStatus: '', hiKetuFlag: '0'},
      {nwJigyosyo: '', tskkJgyosyo: '', gyosyu: '毎年調査（件）', month4: '3,000', month5: '3,000', month6: '3,000', month7: '3,000', month8: '3,000', month9: '3,000', month10: '3,000', month11: '3,000', month12: '3,000', month1: '3,000', month2: '3,000', month3: '3,000', sinnseiStatus: '', hiKetuFlag: '0'},

      {nwJigyosyo: '', tskkJgyosyo: '', gyosyu: '　寝老人', month4: '3,000', month5: '3,000', month6: '3,000', month7: '3,000', month8: '3,000', month9: '3,000', month10: '3,000', month11: '3,000', month12: '3,000', month1: '3,000', month2: '3,000', month3: '3,000', sinnseiStatus: '', hiKetuFlag: '0'},
      {nwJigyosyo: '', tskkJgyosyo: '', gyosyu: '　プール', month4: '3,000', month5: '3,000', month6: '3,000', month7: '3,000', month8: '3,000', month9: '3,000', month10: '3,000', month11: '3,000', month12: '3,000', month1: '3,000', month2: '3,000', month3: '3,000', sinnseiStatus: '', hiKetuFlag: '0'},
      {nwJigyosyo: '', tskkJgyosyo: '', gyosyu: '　公衆浴場', month4: '3,000', month5: '3,000', month6: '3,000', month7: '3,000', month8: '3,000', month9: '3,000', month10: '3,000', month11: '3,000', month12: '3,000', month1: '3,000', month2: '3,000', month3: '3,000', sinnseiStatus: '', hiKetuFlag: '0'},
      {nwJigyosyo: '', tskkJgyosyo: '', gyosyu: '　学校等', month4: '3,000', month5: '3,000', month6: '3,000', month7: '3,000', month8: '3,000', month9: '3,000', month10: '3,000', month11: '3,000', month12: '3,000', month1: '3,000', month2: '3,000', month3: '3,000', sinnseiStatus: '', hiKetuFlag: '0'},
      {nwJigyosyo: '', tskkJgyosyo: '', gyosyu: '　病院等', month4: '3,000', month5: '3,000', month6: '3,000', month7: '3,000', month8: '3,000', month9: '3,000', month10: '3,000', month11: '3,000', month12: '3,000', month1: '3,000', month2: '3,000', month3: '3,000', sinnseiStatus: '', hiKetuFlag: '0'},
      {nwJigyosyo: '', tskkJgyosyo: '', gyosyu: '　老人福祉施設', month4: '3,000', month5: '3,000', month6: '3,000', month7: '3,000', month8: '3,000', month9: '3,000', month10: '3,000', month11: '3,000', month12: '3,000', month1: '3,000', month2: '3,000', month3: '3,000', sinnseiStatus: '', hiKetuFlag: '0'},
      {nwJigyosyo: '', tskkJgyosyo: '', gyosyu: '　重要文化財', month4: '3,000', month5: '3,000', month6: '3,000', month7: '3,000', month8: '3,000', month9: '3,000', month10: '3,000', month11: '3,000', month12: '3,000', month1: '3,000', month2: '3,000', month3: '3,000', sinnseiStatus: '', hiKetuFlag: '0'},
      {nwJigyosyo: '', tskkJgyosyo: '', gyosyu: '　学校・プール', month4: '3,000', month5: '3,000', month6: '3,000', month7: '3,000', month8: '3,000', month9: '3,000', month10: '3,000', month11: '3,000', month12: '3,000', month1: '3,000', month2: '3,000', month3: '3,000', sinnseiStatus: '', hiKetuFlag: '0'},
      {nwJigyosyo: '', tskkJgyosyo: '', gyosyu: '毎年調査（件）', month4: '3,000', month5: '3,000', month6: '3,000', month7: '3,000', month8: '3,000', month9: '3,000', month10: '3,000', month11: '3,000', month12: '3,000', month1: '3,000', month2: '3,000', month3: '3,000', sinnseiStatus: '', hiKetuFlag: '0'},

      {nwJigyosyo: '', tskkJgyosyo: '', gyosyu: '　寝老人', month4: '3,000', month5: '3,000', month6: '3,000', month7: '3,000', month8: '3,000', month9: '3,000', month10: '3,000', month11: '3,000', month12: '3,000', month1: '3,000', month2: '3,000', month3: '3,000', sinnseiStatus: '', hiKetuFlag: '0'},
      {nwJigyosyo: '', tskkJgyosyo: '', gyosyu: '　プール', month4: '3,000', month5: '3,000', month6: '3,000', month7: '3,000', month8: '3,000', month9: '3,000', month10: '3,000', month11: '3,000', month12: '3,000', month1: '3,000', month2: '3,000', month3: '3,000', sinnseiStatus: '', hiKetuFlag: '0'},

      {nwJigyosyo: '', tskkJgyosyo: '', gyosyu: '点検（件）', month4: '3,000', month5: '3,000', month6: '3,000', month7: '3,000', month8: '3,000', month9: '3,000', month10: '3,000', month11: '3,000', month12: '3,000', month1: '3,000', month2: '3,000', month3: '3,000', sinnseiStatus: '', hiKetuFlag: '0'},
      {nwJigyosyo: '', tskkJgyosyo: '', gyosyu: '　同調', month4: '3,000', month5: '3,000', month6: '3,000', month7: '3,000', month8: '3,000', month9: '3,000', month10: '3,000', month11: '3,000', month12: '3,000', month1: '3,000', month2: '3,000', month3: '3,000', sinnseiStatus: '', hiKetuFlag: '0'},
      {nwJigyosyo: '', tskkJgyosyo: '', gyosyu: '　単独', month4: '3,000', month5: '3,000', month6: '3,000', month7: '3,000', month8: '3,000', month9: '3,000', month10: '3,000', month11: '3,000', month12: '3,000', month1: '3,000', month2: '3,000', month3: '3,000', sinnseiStatus: '', hiKetuFlag: '0'},

    ];
    const totalData=[
      {tyousakei: '調査・点検箇所数（件）：', goukei: '　　　　　　　　　　1,234,567  （調査機関事業所別予定件数の計との差：±-3,234）'},
    ];


    this.gridRef.current.setItemsSource(data);
    this.gridTotalRef.current.setItemsSource(totalData);
    return true;
  };

  /**
   * クリア処理
   */
  _reset = async () => {
    this.setState({buttonDisabled2: true, warningMessages: []});
    const values = this.props.values;
    console.log(values);
    await this.props.reset();
    const data =[];
    this.gridRef.current.setItemsSource(data);
    this.gridTotalRef.current.setItemsSource(data);
    return true;
  };

  /**
   * 検索ボタン押下時処理
   * @param {bool} show
   */
  doSearch = async () => {
    this.setState({buttonDisabled2: false});
    this._searchOrder();
  };

  /**
  * ボタンの活性、非活性化
  */
  checkStateUpdate = () => {
    try {
      let bRet = false;

      if (this.gridRef && this.gridRef.current &&
        this.gridRef.current.selectedItemCount() > 0) {
        bRet = true;
      }

      if (bRet) {
        this.setState({buttonDisabled: false});
      } else {
        this.setState({buttonDisabled: true});
      }
    } catch (error) {
      this.props.doShowMessage({
        message: 'TKSCS00001S',
        action: () => {
          this.props.history.push('/login');
        },
      });
    }
  };

  /**
   * 表示ボタン押下時
   */
  doDisplayInfo = async () => {
    this.props.navigate(GMN_PATH.CUSTOMER_SECURITY_INFO);
  };

  /**
   * 新規作成ボタン押下時
   */
  doTenNext = async () => {
    try {
      // const {generalPurposeMap} = this.props;
      // this.props.doSetOrderId(null);
      // this.props.doSetOrderModifiedCondition(null, null);
      // this.props.doClearOrderInfo(); // 前回データをクリア
      // this.props.doSetStbType(getCodeFromGeneralPurposeMap(generalPurposeMap, 'StbType2', 1));
      // this.props.history.push({pathname: '/TenProprietyBasicInfo'});
      let params = {
        // surveyYear,
        mod: 'I',
      };
      // 年度計画登録画面に遷移
      setSessionObject(GMN.ANNUAL_SURVERY_PLAN_INFO.id, params);
      this.props.navigate(GMN_PATH.ANNUAL_SURVERY_PLAN_INFO);
    } catch (error) {
      this.props.doShowMessage({
        message: 'TKSCS00001S',
        action: () => {
          this.props.history.push('/login');
        },
      });
    }
  };
  /**
   * セル結合をカスタム
   * @param {object} wjgGrid wijmo.grid モジュール
   * @param {object} panel 範囲を含むGridPanel
   * @param {number} r セルが含まれる行のインデックス
   * @param {number} c セルが含まれる列のインデックス
   * @param {boolan} clip 結合範囲をグリッドの現在のビュー範囲にクリップするかどうか
   * @return {*} 結合範囲を指定するCellRange
   */
  mergedRange = (wjgGrid, panel, r, c, clip = true) => {
    let rng = new wjgGrid.CellRange(r, c);

    if (panel.cellType == CellType.ColumnHeader) {
      if (r == 0) {
        rng.col = c - (c % 3);
        rng.col2 = rng.col + 2;
        return rng;
      }
      if (r == 0 && ['tsTkGubun1', 'tsTkGubun2'].includes(panel.columns.at(c).binding)) {
        rng.col = 0;
        rng.col2 = 1;
        return rng;
      }
      if (r == 0 && ['tkTkGubun1', 'tkTkGubun2', 'tkTkGubun3'].includes(panel.columns.at(c).binding)) {
        rng.col = 0;
        rng.col2 = 2;
        return rng;
      }
    }

    if (panel.cellType == CellType.Cell) {
      if (c < 3) {
        let pcol = c > 0 ? c - 1 : c;
        let pval = panel.getCellData(r, pcol, false);
        let val = panel.getCellData(r, c, false);

        // 縦結合（up）※現行と前行の列が一致
        while (rng.row > 0 &&
          panel.getCellData(rng.row - 1, c, false) == val &&
          panel.getCellData(rng.row - 1, pcol, false) == pval) {
          rng.row--;
        }
        // 縦結合（down）※現行と前行のが一致
        while (rng.row2 < panel.rows.length - 1 &&
          panel.getCellData(rng.row2 + 1, c, false) == val &&
          panel.getCellData(rng.row2 + 1, pcol, false) == pval) {
          rng.row2++;
        }
        // 横結合
        const data = panel.rows[r].dataItem;
        if (data.syokeiMerge) {
          rng.col = 1;
          rng.col2 = 2;
        }
      } else {

      }
    }
    return rng;
  };

  /**
   * 一覧パーツ取得
   * @param {*} view 設定
   * @return {*} 一覧パーツ
   */
  getViewElem = (view) => {
    if (view.dataType === 'CellMaker') {
      if (view.binding === 'tskkJgyosyo') {
        return <FlexGridColumnGroup
          binding={view.binding}
          header={view.header}
          dataType='String'
          width={view.width}
          cellTemplate= {CellMaker.makeLink({
          // cssClass: 'bf-btn-navy',
            click: (e, ctx) => {
              this.doEditLink(ctx.item.tskkJgyosyo, ctx.item.sinnseiStatus);
            },
            attributes: {
              tabindex: -1,
            },
          })}/>;
      } else if (view.binding === 'sinnseiStatus') {
        return <FlexGridColumnGroup
          binding={view.binding}
          header={view.header}
          dataType='String'
          width={view.width}
          cellTemplate= {CellMaker.makeLink({
          // cssClass: 'bf-btn-navy',
            click: (e, ctx) => {
              this.displayApproval();
            },
            attributes: {
              tabindex: -1,
            },
          })}/>;
      }
    }

    return <FlexGridColumnGroup
      binding={view.binding}
      header={view.header}
      dataType={view.dataType}
      format={view.format}
      width={view.width}
      // cssClass='bf-gray-background'
      isReadOnly={view.readOnly}/>;
  };

  /**
   * 項目フォーマット処理
   *
   * @param {object} s sender
   * @param {string} e event
   */
  formatItemFunction = (s, e) => {
    // 行が存在しない場合は終了
    const rows = s.rows;
    if (rows.length == 0) {
      return;
    }
    if (e.panel.cellType == CellType.Cell) {
      e.cell.style.backgroundColor = '';
      // ReadOnlyのセルか？
      // if (e.cell.ariaReadOnly) {
      //   e.cell.style.backgroundColor = '#e6e6fa';
      // }
    }
    if (e.panel.cellType == CellType.Cell) {
      const col = e.getColumn();
      const data = s.rows[e.row].dataItem;
      if (col && ((col.binding === 'sinnseiStatus' &&
        data.hiKetuFlag === '1') )) {
        // e.cell.style.backgroundColor = '#fff0f5';
        e.cell.style.backgroundColor = '#ff0000';
      }
    }
  };

  /**
   * 合計一覧描画
   * @return {*}
   */
  renderTotalTable() {
    const props = {
      rowHeaderType: 'None',
      id: 'SCE1002HenkomaeTable',
      filterOn: true,
      headersVisibility: 'None',
      allowDragging: 'Columns',
      style: {height: 'auto', maxHeight: 'auto', maxWidth: 'auto', width: 'auto', marginTop: '0px'},
      isReadOnly: false,
      screenId: 'SCE1002Henkomae',
      checkedFunction: this.checkStateUpdate,
      doShowMessage: this.props.doShowMessage,
      validateEdits: false,
      // DeleteOn: true,
      getError: this.getError,

    };
    // 一覧定義取得
    let viewElems = [];
    if (totalViews) {
      for (const view of totalViews) {
        let viewElem;
        if (view.dataType === 'header') {
          let viewGroups = [];
          for (const elem of view.elems) {
            if (elem.dataType === 'Select') {
              viewGroups.push(this.getViewElemComboBox(elem, false));
            } else {
              viewGroups.push(this.getViewElem(elem));
            }
          }
          viewElem = <FlexGridColumnGroup header={view.header}>
            {viewGroups}
          </FlexGridColumnGroup>;
        } else if (view.dataType === 'Select') {
          viewElem = this.getViewElemComboBox(view, false);
        } else {
          viewElem = this.getViewElem(view);
        }
        viewElems.push(viewElem);
      }
    }

    return (
      // <CustomFlexGrid frozenRows={1} ref={this.gridRef} {...props}>
      <CustomFlexGrid ref={this.gridTotalRef} {...props}>
        {viewElems}
      </CustomFlexGrid>
    );
  }
  /**
   * 承認状況画面の表示
   */
  displayApproval = () => {
    this.setState({
      showApprovalModal: true,
    });
  };

  /**
 * 承認状況画面を閉じる
 */
  closeApproval = () => {
    this.setState({
      showApprovalModal: false,
    });
  };
  /**
   * 否認画面の表示
   * @param {string} type
   */
  displayApprovalCommentTstk = (type) => {
    this.setState({
      showApprovalCommentTstkModal: true,
      approvalType: type,
    });
  };

  /**
 * 否認画面を閉じる
 */
  closeApprovalCommentTstk = () => {
    this.setState({
      showApprovalCommentTstkModal: false,
    });
  };

  doSyoninShinsei = () => {
    this.props.doShowMessage({
      message: {
        id: 'BFY000009I',
        values: ['承認申請'],
      },
    });
  };

  doApprove = () => {
    this.props.doShowMessage({
      message: {
        id: 'BFY000009I',
        values: ['承認'],
      },
    });
  };

  doConfirm = () => {
    this.props.doShowMessage({
      message: {
        id: 'BFY000009I',
        values: ['確認'],
      },
    });
  };
  /**
   * 一覧表示
   * @return {object}
   */
  renderTable() {
    const props = {
      rowHeaderType: 'check',
      filterOn: false,
      // exceptFilters: exceptFiltersBindings,
      headersVisibility: 'Column',
      allowDragging: 'None',
      allowSorting: 'SingleColumn',
      AddDeleteOn: false,
      style: {maxHeight: 'auto', maxWidth: 'auto', height: 'auto', width: 'auto'},
      isReadOnly: true,
      checkedFunction: this.checkStateUpdate,
      formatItemFunction: this.formatItemFunction,
      // customMergedRange: this.mergedRange,
    };

    let viewElems = [];
    if (planViews) {
      for (const view of planViews) {
        let viewElem;
        if (view.dataType === 'header') {
          let viewGroups = [];
          for (const elem of view.elems) {
            if (elem.dataType === 'Select') {
              viewGroups.push(this.getViewElemComboBox(elem, false));
            } else {
              viewGroups.push(this.getViewElem(elem));
            }
          }
          viewElem = <FlexGridColumnGroup header={view.header}>
            {viewGroups}
          </FlexGridColumnGroup>;
        } else if (view.dataType === 'Select') {
          viewElem = this.getViewElemComboBox(view, false);
        } else {
          viewElem = this.getViewElem(view);
        }
        viewElems.push(viewElem);
      }
    }

    return (
      <CustomFlexGrid ref={this.gridRef} {...props}>
        {viewElems}
      </CustomFlexGrid>
    );
  }

  /**
   * 一覧リンククリック時
   * @param {*} tskkJgyosyo 調査機関事業所
   * @param {*} sinnseiStatus ステータス
   */
  doEditLink = async (tskkJgyosyo, sinnseiStatus) => {
    try {
      let params = {
        tskkJgyosyo,
        mod: 'C',
      };
      if (sinnseiStatus =='作成中' || sinnseiStatus =='取止済') {
        params = {
          tskkJgyosyo,
          mod: 'C',
        };
      } else if (sinnseiStatus =='報告中'|| sinnseiStatus =='申請内容確認中'|| sinnseiStatus =='承認待ち') {
        params = {
          tskkJgyosyo,
          // mod: 'U',
          mod: 'C',
        };
      } else if (sinnseiStatus =='完了') {
        params = {
          tskkJgyosyo,
          // mod: 'W',
          mod: 'C',
        };
      } else {
        params = {
          tskkJgyosyo,
          mod: 'C',
        };
      }

      // 年度計画登録画面に遷移
      setSessionObject(GMN.ANNUAL_SURVERY_PLAN_INFO.id, params);
      this.props.navigate(GMN_PATH.ANNUAL_SURVERY_PLAN_INFO);
    } catch (error) {
      this.props.doShowMessage({
        message: 'TKSCS00001S',
        action: () => {
          this.props.history.push('/login');
        },
      });
    }
  };

  /**
   * 検索条件タブの要素生成
   * @return {React.JSX.Element|null} タブのJSX要素
   */
  renderCondition() {
    return (
      <React.Fragment>
        <Grid
          container
          justifyContent="flex-start"
          alignItems="flex-start"
          spacing={1}
          direction={'row'}
        >
          <Grid key="surveyYear" item xs={12} sm={1}>
            <Field
              id="surveyYear"
              name="surveyYear"
              component={renderSelect}
              className="fields"
              label="年度"
              type="text"
              fullWidth
              required={true}
              // validate={[
              //   validateRule.number,
              //   validateRule.maxLength(4),
              // ]}
            >
              <MenuItem value="">&nbsp;</MenuItem>
              <MenuItem value={1}>{'2026'}</MenuItem>
              <MenuItem value={2}>{'2025'}</MenuItem>
              <MenuItem value={3}>{'2024'}</MenuItem>
            </Field>
          </Grid>
          <Grid key="zigyoujo" item xs={12} sm={2}>
            <Field
              id="zigyoujo"
              name="zigyoujo"
              // variant="standard"
              component={renderSelect}
              className="fields"
              label="NW事業所"
              type="text"
              fullWidth
              required={false}
              validate={[
              ]}
              InputProps={{
                readOnly: false,
              }}
            >
              <MenuItem value="">&nbsp;</MenuItem>
              <MenuItem value={5160}>{'広島北'}</MenuItem>
              {/* <MenuItem value={6120}>{'山口'}</MenuItem> */}
            </Field>
          </Grid>
          <Grid key="zigyoujoBefore" item xs={12} sm={2}>
            <Field
              id="zigyoujoBefore"
              name="zigyoujoBefore"
              // variant="standard"
              component={renderSelect}
              className="fields"
              label="旧NW事業所"
              type="text"
              fullWidth
              required={false}
              validate={[
              ]}
              InputProps={{
                readOnly: false,
              }}
            >
              <MenuItem value="">&nbsp;</MenuItem>
              <MenuItem value={5160}>{'広島北'}</MenuItem>
              <MenuItem value={5170}>{'廿日市'}</MenuItem>
            </Field>
          </Grid>
          <Grid key="tyousakikan" item xs={12} sm={2}>
            <Field
              id="tyousakikan"
              name="tyousakikan"
              // variant="standard"
              component={renderSelect}
              className="fields"
              label="調査会社"
              type="text"
              fullWidth
              required={true}
              validate={[
              ]}
              InputProps={{
                readOnly: false,
              }}
            >
              <MenuItem value="">&nbsp;</MenuItem>
              <MenuItem value={3000}>{'保安協会'}</MenuItem>
              <MenuItem value={5000}>{'工業組合'}</MenuItem>
            </Field>
          </Grid>
          <Grid key="tskkJgyosyo" item xs={12} sm={2}>
            <Field
              id="tskkJgyosyo"
              name="tskkJgyosyo"
              // variant="standard"
              component={renderSelect}
              className="fields"
              label="調査機関事業所"
              type="text"
              fullWidth
              required={false}
              validate={[
              ]}
              InputProps={{
                readOnly: false,
              }}
            >
              <MenuItem value="">&nbsp;</MenuItem>
              <MenuItem value={4500}>{'広島支'}</MenuItem>
              {/* <MenuItem value={4580}>{'府中支'}</MenuItem> */}

            </Field>
          </Grid>
          <Grid key="states" item xs={12} sm={2}>
            <Field
              id="states"
              name=""
              // variant="standard"
              component={renderSelectMultiLine}
              className="fields"
              label="ステータス"
              type="text"
              fullWidth
              required={false}
              validate={[
              ]}
              InputProps={{
                readOnly: false,
              }}
            >
              <MenuItem value="">&nbsp;</MenuItem>
              <MenuItem value={10}>{'作成中'}</MenuItem>
              <MenuItem value={20}>{'報告中'}</MenuItem>
              <MenuItem value={30}>{'確認中'}</MenuItem>
              <MenuItem value={40}>{'承認中'}</MenuItem>
              <MenuItem value={90}>{'完了'}</MenuItem>
            </Field>
          </Grid>
        </Grid>
      </React.Fragment>
    );
  };

  /**
   * フッタボタン
   * @return {JSX.Element}
   */
  renderFooterBtn() {
    // const {
    //   handleSubmit,
    // } = this.props;

    return (
      <Grid
        container
        justifyContent="center"
        alignItems="flex-start"
        spacing={1}
      >
        <Grid key="key1001CreateTen3" item>
          <PositiveButton
            id="btn1001CreateTen3"
            onClick={this.doSyoninShinsei}
            variant="contained"
            startIcon={<SaveIcon />}
            // onClick={this.doDelete}
            // size="large"
          >
            <span>承認申請</span>
            {/* <InfoOutlined fontSize="small"/> */}
          </PositiveButton>
        </Grid>
        {/* <Grid key="key1001CreateTen4" item>
          <PositiveButton
            id="btn1001CreateTen4"
            onClick={this.doApprove}
            variant="contained"
            startIcon={<CheckCircle />}
            // onClick={this.doDelete}
            // size="large"
          >
            <span>調査機関承認</span>
          </PositiveButton>
        </Grid> */}
        {/* <Grid key="key1001CreateTen4" item>
          <PositiveButton
            id="btn1001CreateTen4"
            onClick={this.doConfirm}
            variant="contained"
            startIcon={<CheckCircle />}
            // onClick={this.doDelete}
            // size="large"
          >
            <span>確認</span>
          </PositiveButton>
        </Grid> */}

        <Grid key="key1001CreateTen4" item>
          <PositiveButton
            id="btn1001CreateTen4"
            onClick={()=>{
              this.displayApprovalCommentTstk('1');
            }}
            variant="contained"
            startIcon={<CheckCircle />}
            // onClick={this.doDelete}
            // size="large"
          >
            <span>承認</span>
          </PositiveButton>
        </Grid>
        <Grid key="key1001CreateTen4" item>
          <DangerButton
            id="btn1001CreateTen4"
            onClick={() => {
              this.displayApprovalCommentTstk('2');
            }}
            variant="contained"
            startIcon={<Cancel />}
            // onClick={this.doDelete}
            // size="large"
          >
            <span>否決</span>
          </DangerButton>
        </Grid>

        {/* <Grid key="key1001CreateTen4" item>
          <PositiveButton
            id="btn1001CreateTen4"
            onClick={this.displayApproval}
            variant="contained"
            // startIcon={<SaveIcon />}
            // onClick={this.doDelete}
            // size="large"
          >
            <span>承認状況</span>
          </PositiveButton>
        </Grid> */}
      </Grid>
    );
  };

  render() {
    const {classes,
      // generalPurposeMap,
      // reset,
      handleSubmit,
      // values,
      //  userInfo
    } = this.props;

    // フッタボタンを生成
    const footerBtn = this.renderFooterBtn();

    // タブとタブパネルを生成
    // const tabElements = this._createTabElements();

    return (
      <form noValidate autoComplete="off" className={classes.root}>
        <MainContainer
          props={this.props}
          footerBtn={footerBtn}>
          <CustomBreadcrumbs key="keyBreadcrumbs" items={transitionList}/>
          <Grid key="keySCA1001Msg" item xs={12}>
            <WarningMessageArea messages={this.state.warningMessages}/>
          </Grid>
          <PaperPart>
            <Grid
              container
              justifyContent="flex-start"
              alignItems="flex-start"
              spacing={1}
            >
              <Grid key="search" item xs={12}>
                <CustomAccordion title='検索条件' items={[this.renderCondition()]} defaultExpanded={true}/>
              </Grid>
            </Grid>
            <Grid
              container
              justifyContent="right"
              alignItems="right"
            >
              <Grid key="clear" item>
                <NegativeButton
                  id="clear"
                  variant="contained"
                  startIcon={<RotateLeftIcon />}
                  className="button_list"
                  size="middle"
                  onClick={handleSubmit(this._reset)}
                >
                  <span>クリア</span>
                </NegativeButton>
              </Grid>
              <Grid key="search" item>
                <PositiveButton
                  id="search"
                  variant="contained"
                  startIcon={<SearchIcon />}
                  className="button_list"
                  size="middle"
                  onClick={handleSubmit(this.doSearch)}
                >
                  <span>検索</span>
                </PositiveButton>
              </Grid>
            </Grid>
          </PaperPart>
          <div style={{marginBottom: '20px'}} />
          <Divider variant="middle" />
          <div style={{marginBottom: '20px'}} />
          <Grid container
            justifyContent="flex-start"
            alignItems="flex-end"
          >
            <Grid key="keySCA1002HenkomaeTable" item xs={12}>
              {this.renderTotalTable()}
            </Grid>
            <Grid key="keySCA1002HenkomaeTable" item xs={12} sm='4'>
              <div style={{marginBottom: '-10px'}} />
              <Typography variant="h8" gutterBottom align="right">(20日締め)</Typography>
              <div style={{marginBottom: '10px'}} />
            </Grid>
            <Grid
              container
              justifyContent="flex-start"
              alignItems="flex-end"
              direction={'row'}
            >
              {this.renderTable()}
            </Grid>

          </Grid>
        </MainContainer>
        <ApprovalStatus
          openState={this.state.showApprovalModal}
          // handleExec={handleSubmit(this.displaySpecification)}
          // handleExec={this.displayApprovalModal}
          handleClose = {this.closeApproval}/>
        <ApprovalCommentTstk
          openState={this.state.showApprovalCommentTstkModal}
          tstk={false}
          approvalType={this.state.approvalType}
          // handleExec={handleSubmit(this.displaySpecification)}
          // handleExec={this.displayApprovalModal}
          handleClose = {this.closeApprovalCommentTstk}/>
      </form>
    );
  }
}

Container.propTypes = {
  classes: PropTypes.object,
  generalPurposeMap: PropTypes.object,
  orderList: PropTypes.array,
  history: PropTypes.object,
  values: PropTypes.object,
  userInfo: PropTypes.object,
  order: PropTypes.object,
  reset: PropTypes.func,
  handleSubmit: PropTypes.func,
  doShowMessage: PropTypes.func,
  doGetOrderTypeList: PropTypes.func,
  doSetOrderId: PropTypes.func,
  doDeleteProprietyOrder: PropTypes.func,
  doClearOrderInfo: PropTypes.func,
  doSetStbType: PropTypes.func,
  doClearOrderList: PropTypes.func,
  doRetrieveOrder: PropTypes.func,
  doClearOrder: PropTypes.func,
  doSetReferenceMode: PropTypes.func,
  doSetOrderModifiedCondition: PropTypes.func,
  doSetInitValues: PropTypes.func,
  navigate: PropTypes.func,
};

const mapStateToProps = (state) => {
  return {
    generalPurposeMap: state.common.generalPurposeMap,
    userInfo: state.auth.userInfo,
    orderList: state.attachorder.orderList,
    order: state.attachorder.order,
    initialValues: {
      surveyYear: '1',
      zigyoujo: '5160',
      tyousakikan: '3000',
    },
    // initialValues: state.common.setInitValues,
  };
};

const mapDispatchToProps = {
  doShowMessage: commonOperations.doShowMessage,
  doGetOrderTypeList: attachorderOperations.doGetOrderTypeList,
  doSetOrderId: attachorderOperations.doSetOrderId,
  doDeleteProprietyOrder: attachorderOperations.doDeleteProprietyOrder,
  doClearOrderInfo: attachorderOperations.doClearOrderInfo,
  doSetStbType: commonOperations.doSetStbType,
  doClearOrderList: attachorderOperations.doClearOrderList,
  doRetrieveOrder: attachorderOperations.doRetrieveOrder,
  doClearOrder: attachorderOperations.doClearOrder,
  doSetReferenceMode: commonOperations.doSetReferenceMode,
  doSetOrderModifiedCondition:
    attachorderOperations.doSetOrderModifiedCondition,
  doSetInitValues: commonOperations.doSetInitValues,
};

const FORM_NAME = 'ProprietyJudgingList';

Container = reduxForm({
  form: FORM_NAME,
  destroyOnUnmount: false,
  enableReinitialize: true,
})(connect((state) => {
  return {
    values: getFormValues(FORM_NAME)(state),
  };
})(Container));

export default withStyles(styles)(
    connect(
        mapStateToProps,
        mapDispatchToProps,
    )(withRouter(Container)),
);

